<script lang="ts">
    export let size: number;
    export let color: string = "#000000";
</script>

<!--https://dev.materialdesignicons.com/icon/sort-descending-->
<svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        width={size}
        height={size}
        viewBox="0 0 {size} {size}">
    <path
            fill={color}
            d="M19 7H22L18 3L14 7H17V21H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z"/>
</svg>
